document.addEventListener("alpine:init", () => {
  Alpine.data("newsletterSignUp", (nonce, apiUrl = "/wp-json/v1/newsletter-signup") => ({
    open: false,
    isLoading: false,
    feedbackMsg: "",
    isSuccess: false,

    async submitForm() {
      this.isLoading = true;
      this.feedbackMsg = "";

      // Formulardaten sammeln
      const form = this.$refs.signupForm;
      const formData = new FormData(form);

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "X-WP-Nonce": nonce,
          },
          body: formData,
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Ein Fehler ist aufgetreten");
        }

        // Erfolg
        this.isSuccess = true;
        this.feedbackMsg = result.message;
        form.reset();

        // Modal automatisch schließen
        setTimeout(() => {
          if (this.open) {
            this.open = false;
            // State zurücksetzen, wenn Modal zu ist
            setTimeout(() => {
              this.isSuccess = false;
              this.feedbackMsg = "";
            }, 500);
          }
        }, 2000);
      } catch (error) {
        this.isSuccess = false;
        this.feedbackMsg = error.message;
      } finally {
        this.isLoading = false;
      }
    },
  }));
});
